import React from "react";
import { styled } from "@mui/material/styles";

import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, FormControlLabel, Checkbox, IconButton, Stack } from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

import PersonOffIcon from "@mui/icons-material/PersonOff";
import PersonIcon from "@mui/icons-material/Person";
import PersonOutlinedIcon from "@mui/icons-material/PersonOutlined";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";

import { displayFullName } from "../../../../utilities/formatters";


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.common.white,
        padding: 12,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 18,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    "&:last-child td, &:last-child th": {
        border: 0,
    },
}));


const AssessorStatusIcon = ({ status, isSelf, isFacilitator }) => {
    if (isSelf) {
        return <PersonOutlinedIcon color="success" />;
    }
    switch (status) {
        case "approved":
            return <PersonIcon color="success" />;
        case "modified":
        case "proposed":
            return <PersonIcon color={isFacilitator ? "warning" : "disabled"} />;
        case "rejected":
            return <PersonOffIcon color="error" />;
        case "error":
            return <PersonIcon color="error" />;
        default:
            return <PersonIcon color="disabled" />;
    }
};


function RecipientsTable({ recipients = [], isFacilitator, onDelete, onApprove, userId }) {

    return (
        <TableContainer>
            <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                    <TableRow>
                        <StyledTableCell>Name</StyledTableCell>
                        <StyledTableCell>Job role</StyledTableCell>
                        <StyledTableCell>Email</StyledTableCell>
                        {!!isFacilitator && (
                            <StyledTableCell>Approved</StyledTableCell>
                        )}
                        <StyledTableCell>&nbsp;</StyledTableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {recipients.map((recipient, index) => (
                        <StyledTableRow key={index}>
                            <StyledTableCell>
                                {displayFullName(recipient)}
                            </StyledTableCell>
                            <StyledTableCell>
                                {recipient.jobRole}
                            </StyledTableCell>
                            <StyledTableCell>{recipient.email}</StyledTableCell>
                            {!!isFacilitator && (
                                <StyledTableCell>
                                    {userId !== recipient.uuid && recipient.nomination?.status === 'proposed' && (
                                        <FormControlLabel
                                            label={null}
                                            control={
                                                <Checkbox
                                                    id={`${recipient.uuid}_status`}
                                                    defaultChecked={recipient?.nomination?.status === 'approved'}
                                                    onChange={({target}) => onApprove(recipient.uuid, target.checked)}
                                                />
                                            }
                                        />
                                    )}
                                </StyledTableCell>
                            )}
                            <StyledTableCell align="right">
                                <Stack
                                    direction="row"
                                    justifyContent="flex-end"
                                    spacing={0}
                                >
                                    <AssessorStatusIcon
                                        status={recipient.nomination?.status}
                                        isSelf={userId === recipient.uuid}
                                        isFacilitator={isFacilitator}
                                    />

                                    {!!onDelete && !!recipient.canDelete && (
                                        <IconButton
                                            aria-label="delete"
                                            onClick={() => onDelete(recipient.uuid)}
                                        >
                                            <DeleteOutlinedIcon />
                                        </IconButton>
                                    )}
                                </Stack>
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default RecipientsTable;
